import {
	FontIconName,
	IconButton,
	IconColor
} from "client/Components";
import { ReactElement, Ref } from "react";

export type VisibilityActionState = "visible" | "hidden";

export type VisibilityActionButtonProps = {
	state: VisibilityActionState;
	onClick: () => void;
	ref?: Ref<HTMLButtonElement>;
};

export const VisibilityActionButton = (props: VisibilityActionButtonProps): ReactElement => {
	const {
		state,
		onClick,
		ref
	} = props;

	return (
		<IconButton
			icon={{
				kind: "font",
				name: stateToIcon[state],
				color: stateToColor[state]
			}}
			kind="transparent-colored"
			onClick={onClick}
			bubbleClick={false}
			trackingId="toggle-visibility"
			ref={ref}
		/>
	);
};
VisibilityActionButton.displayName = "VisibilityActionButton";

const stateToIcon: { [key in VisibilityActionState]: FontIconName; } = {
	"visible": "eye",
	"hidden": "eye-slash"
};

const stateToColor: { [key in VisibilityActionState]: IconColor; } = {
	"visible": "success",
	"hidden": "danger"
};